import { NativeDateAdapter } from '@angular/material/core';

export class CustomDateAdapter extends NativeDateAdapter {
  // Override parse method to accept the desired date format
  override parse(value: any): Date | null {
    if (typeof value === 'string' && value.includes('-')) {
      const [day, month, year] = value.split('-');
      return new Date(Number(year), Number(month) - 1, Number(day));
    }
    return super.parse(value);
  }

  // Override format method to return the desired date format
  override format(date: Date, displayFormat: string): string {
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();

    return `${this._to2digit(day)}-${this._to2digit(month)}-${year}`;
  }

  private _to2digit(n: number) {
    return ('00' + n).slice(-2);
  }
}
